export default __webpack_public_path__ + "static/media/hero2.391cb082.png";